var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('OurHistory'),_c('AboutUs'),_c('OurCooperation'),_c('OurLocation'),_c('OurFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }